import type { IdentifierDefinitionDto } from '@/api/client';

/**
 * The user-facing name of an identifier definition — the admin-configured
 * `label` ("MRN"), never the internal `userEnteredId` ("fhirId"). Falls back to
 * the internal id so a row whose definition was deleted still renders something.
 */
export function identifierDefinitionLabel(
  definition: IdentifierDefinitionDto | undefined,
  fallback = '',
): string {
  const label = definition?.label;
  if (label !== undefined && label.length > 0) return label;
  const userEnteredId = definition?.userEnteredId;
  if (userEnteredId !== undefined && userEnteredId.length > 0) return userEnteredId;
  return fallback;
}

/**
 * Display label for an identifier held on a person, resolved against the tenant
 * catalog. Precedence: catalog label → the label stored on the row itself (set
 * when the row was written, possibly before the admin renamed the type) → the
 * internal id.
 */
export function identifierLabelFor(
  definitions: readonly IdentifierDefinitionDto[] | undefined,
  userEnteredId: string,
  rowLabel?: string | null,
): string {
  const definition = definitions?.find((d) => d.userEnteredId === userEnteredId);
  if (definition !== undefined) return identifierDefinitionLabel(definition, userEnteredId);
  if (rowLabel !== null && rowLabel !== undefined && rowLabel.length > 0) return rowLabel;
  return userEnteredId;
}
